(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PrefectureDialogController', PrefectureDialogController);

    PrefectureDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Prefecture', 'Region'];

    function PrefectureDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Prefecture, Region) {
        var vm = this;
        vm.prefecture = entity;
        vm.regions = Region.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:prefectureUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.prefecture.id !== null) {
                Prefecture.update(vm.prefecture, onSaveSuccess, onSaveError);
            } else {
                Prefecture.save(vm.prefecture, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
